// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Ay0Z","bigColWidth":"Table_bigColWidth__2U1Jd","biggerColWidth":"Table_biggerColWidth__3izZt","row":"Table_row__3iQAx","col":"Table_col__1tVnP"};